export default __webpack_public_path__ + "static/media/RCHITable.df2bdde6.jpeg";